var _path, _rect, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgC1E = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 224 68"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M0 43a3 3 0 0 1 3-3h87a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-.278c-1.562 0-2.823-1.218-3.304-2.703C84.857 49.482 80.335 46 75 46s-9.857 3.482-11.418 8.297C63.101 55.782 61.84 57 60.278 57H35.722c-1.562 0-2.823-1.218-3.304-2.703C30.857 49.482 26.335 46 21 46s-9.857 3.482-11.418 8.297C9.101 55.782 7.84 57 6.278 57H3a3 3 0 0 1-3-3z",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 92,
  height: 37,
  x: 1,
  fill: "#000",
  rx: 2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M21 68c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12M75 68c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12M98 43a3 3 0 0 1 3-3h120a3 3 0 0 1 3 3v11.896A2.104 2.104 0 0 1 221.896 57c-1.095 0-1.987-.848-2.251-1.91C218.344 49.869 213.624 46 208 46c-5.335 0-9.857 3.482-11.418 8.297-.481 1.485-1.742 2.703-3.304 2.703h-59.556c-1.562 0-2.823-1.218-3.304-2.703C128.857 49.482 124.335 46 119 46s-9.857 3.482-11.418 8.297c-.481 1.485-1.742 2.703-3.304 2.703H101a3 3 0 0 1-3-3z",
  clipRule: "evenodd"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 37,
  x: 99,
  fill: "#000",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M196 0a3 3 0 0 0-3 3v40a3 3 0 0 0 3 3h25a3 3 0 0 0 3-3V22.884c0-.324-.052-.646-.155-.953l-6.659-19.884A3 3 0 0 0 214.341 0zm4 4a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h15.759c2.07 0 3.518-2.047 2.829-3.999l-4.59-13A3 3 0 0 0 211.169 4zM119 68c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12M208 68c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m0-4a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
  clipRule: "evenodd"
})));
export default SvgC1E;